import { Badge } from '@/components/ui/badge';
import { CheckCircle, Clock, XCircle, Ban } from 'lucide-react';

interface VendorInvitationStatusBadgeProps {
  status: 'pending' | 'accepted' | 'expired' | 'cancelled';
}

export const VendorInvitationStatusBadge: React.FC<VendorInvitationStatusBadgeProps> = ({ status }) => {
  const statusConfig = {
    pending: {
      label: 'Pending',
      variant: 'secondary' as const,
      icon: Clock,
      className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
    },
    accepted: {
      label: 'Accepted',
      variant: 'default' as const,
      icon: CheckCircle,
      className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    },
    expired: {
      label: 'Expired',
      variant: 'secondary' as const,
      icon: XCircle,
      className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300'
    },
    cancelled: {
      label: 'Cancelled',
      variant: 'destructive' as const,
      icon: Ban,
      className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
    }
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`${config.className} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
};
